export default __webpack_public_path__ + "static/images/arrow-451ad0aad1908f9074aa2c67ee83541c.png";